import { Themes } from '@/constants/Colors';

// Catalogs share the app's theme colors instead of flattening every theme
// into a neutral light/dark pair. Keep stable objects for memoized styles.
const palettes = Object.fromEntries(Object.entries(Themes).map(([theme, colors]) => [theme, {
  surface: colors.solid_color_block,
  preview: colors.solid_color_tertiary,
  hover: colors.solid_color_tertiary,
  control: colors.solid_color_primary,
  border: colors.border_color_secondary,
  activeBorder: colors.text_color_tertiary,
  selected: colors.solid_color_secondary,
  ink: colors.text_color_primary,
  onInk: colors.solid_color_primary,
  icon: colors.text_color_secondary,
}]));

export const getCatalogPalette = theme => palettes[theme] || palettes.white;
